import { Mesh } from "three";
import { EMaterialSlot } from "./EMaterialSlot";

export class MeshInfo {
    
    public mesh!: Mesh;
    public subMeshMap: Map<EMaterialSlot, number>;

    constructor() {
        this.subMeshMap = new Map();
    }
}